import { useProjects } from '@cascade/react/projects';
import { useTheme } from '@cascade/ui-library';
import colors from '@cascade/ui-library/styles/colors.module.scss';
import { useEffect } from 'react';
import type { PropsWithChildren } from 'react';

export const ProjectThemeProvider = ({ children }: PropsWithChildren) => {
  const { settings } = useProjects();
  const { config, updateTheme } = useTheme();

  const brand = settings?.project_theme?.default_primary ?? colors.defaultBrand;
  const isApplied = config.brand === brand;

  useEffect(() => {
    if (isApplied) {
      return;
    }

    updateTheme({ brand });
  }, [brand, isApplied, updateTheme]);

  return children;
};
